import { MultiLingualComponent } from './multi-lingual/multi-lingual.component';

import { TranslateService, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { NgModule, ModuleWithProviders } from '@angular/core';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EmailComponent } from './component/email/email.component';


export function translateLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
};
@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,TranslateModule
  ],

  declarations: [MultiLingualComponent, EmailComponent],
  providers: [TranslateStore],
  exports: [
    CommonModule,
    TranslateModule,
    MultiLingualComponent,
    EmailComponent
  ]
})
export class SharedTranslateLazyModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedTranslateLazyModule,
      providers: [TranslateStore, TranslateService]
    }
  }
  constructor() {


  }
}
